import Header from "../../components/Header";
import HeroSection from "./components/HeroSection";
import RevolutionSection from "./components/RevolutionSection";
import SimplifySection from "./components/SimplifySection";
import BuildingSection from "./components/BuildingSection";
import StaySection from "./components/StaySection";
import Footer from "../../components/Footer";
import Video from "./components/Video";
import ToolsSection from "./components/ToolsSection";
import Reviews from "./components/Reviews";

function LandingPage() {
  return (
    <div>
      <Header />
      <HeroSection />
      <div
        style={{ backgroundImage: "url(/home.png)", backgroundSize: "cover" }}
      >
        <Video />
        <ToolsSection />
        <RevolutionSection />
        <SimplifySection />
        <Reviews />
        <BuildingSection />
        <StaySection />
      </div>
      <Footer />
    </div>
  );
}

export default LandingPage;
